import React from 'react'

export default function HomeAbout() {
    return (
        <>
            <div className="homeabout">
                <div className="container">
                    <div className="row justify-content-center">

                        <div className="col-lg-9">
                            <p className="wow animate__animated animate__slideInUp" data-wow-duration="1s" data-wow-delay="0.1s">Rooted in a legacy of excellence since 1988, Lucknow Public School has emerged as one of
                                Uttar Pradesh's leading educational institutions. Across 10 campuses, we inspire young
                                minds through Discipline, Quality, and Value-Based Education, empowering every student
                                to excel academically, lead with integrity, and serve society with compassion and purpose.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
